import { Log } from '@apparel/core/log';
import { isApparel } from '@apparel/core/platform';

declare function gtag(...args: any[]);

export class GoogleTagService {
    private static self: GoogleTagService;

    static get instance() {
        if (!this.self) {
            this.self = new GoogleTagService();
        }

        return this.self;
    }

    reportConversion(key) {
        gtag('event', 'conversion', {
            send_to: `AW-391337609/${key}`,
        });
    }

    public static reportConversion(key) {
        try {
            if (isApparel()) {
                return this.instance.reportConversion(key);
            }
        } catch (error) {
            Log.error('Error reporting conversion tag.', { error });
        }
    }
}
